import type { ISyncList } from '@/libs/types/sync';

export type DashboardInterviewStatus =
  | 'Descartada'
  | 'Válida'
  | 'Não Considerada';

export function mapInterviewStatus({
  is_discarted: isDiscarded,
  status,
}: Pick<ISyncList, 'is_discarted' | 'status'>): DashboardInterviewStatus {
  if (isDiscarded) {
    return 'Descartada';
  }

  if (status?.trim().toLowerCase() === 'fraude') {
    return 'Não Considerada';
  }

  return 'Válida';
}
